import React, {FormEvent, useEffect, useState} from "react";
import {Button} from "@material-ui/core";
import {FlowableFormField, FormFieldType, FormState} from "../types/FlowableFormTypes";
import {renderField} from "./FieldRenderer";
import axios from "axios";
import config from "../config";

const removeFieldValidation: string[] = [
    'applicationsystemidentifier',
    'emassidentifier',
    'sorn'
];

const formatField = (field: FlowableFormField) => {
    if (field.id === 'applicationsystemidentifiertype') {
        return {
            readOnly: false,
            params: undefined,
            type: 'dropdown' as FormFieldType,
            options: [
                {"id":"","name":"Please choose one..."},
                {"id":"AITR","name":"AITR"},
                {"id":"DITPR","name":"DITPR"},
                {"id":"Other","name":"Other"}
            ]
        };
    }
    return {readOnly: false, params: removeFieldValidation.includes(field.id) ? undefined: field.params};
}

export const EditField = (props: {field: FlowableFormField, fields: FlowableFormField[], formState: FormState, processInstanceId: string, loadData: () => Promise<void>, applications?: FlowableFormField[][], applicationIndex?: number}): JSX.Element => {
    const [editing, setEditing] = useState<boolean>(false);
    const [saving, setSaving] = useState<boolean>(false);
    const [formState, setFormState] = useState<FormState>({...props.formState, ...{name: props.formState.value}});

    useEffect(() => {
        setFormState({...props.formState, ...{name: props.formState.value}});
    }, [props.formState]);

    const handleChange = (fs: FormState) => {
        setFormState(fs);
    }

    const addToFormState = (fs: FormState, key: string, value: unknown) => {
        return {...fs, ...{[key]: value}};
    }

    async function submitForm() {
        const fieldId = props.applications ? 'applications' : props.field.id;
        const fieldValue = props.applications ? props.applications.map((application, index) => {
            if (index === props.applicationIndex) {
                return formState;
            }
            return application.reduce((accumulator: FormState,currentValue: FlowableFormField) => {
                return {...accumulator, ...{[currentValue.id]: currentValue.value}};
            }, {} as Record<string, never>);
            }) : formState[props.field.id];

        await axios.put(`${config.flowableUiApiBaseUrl}admin-app/rest/admin/process-instances/${props.processInstanceId}/variables/${fieldId}`, {
            "name": fieldId,
            "value": fieldValue
        }, {withCredentials: true, responseType: 'json'}).catch(() => {
            console.log('caught error' )
        }).then((response) => {
            if (response) {
                if (response.status === 200) {
                    props.loadData();
                    setEditing(false);
                } else {
                   console.log('error', response)
                }

            }
        });
    }

    return editing ?
        <form onSubmit={(e: FormEvent<HTMLFormElement>): void => {
            e.preventDefault();
            setSaving(true);
            submitForm();
            setSaving(false);
        }}>
            {renderField({...props.field, ...formatField(props.field)}, props.fields, formState, handleChange, addToFormState, null, false)}
            <Button onClick={() => setEditing(false)} variant="contained" size="small">Cancel</Button>{' '}
            <Button color="primary" variant="contained" size="small" type="submit">{saving ? 'Saving' : 'Save'}</Button>
        </form> :
        <>
            (<a href="#" onClick={e => {e.preventDefault(); setEditing(true);}}>
                edit
            </a>)
        </>
}